<template>
  <div id="dashboard">
    <CharacterList/>

    <RecentNews></RecentNews>
  </div>
</template>

<script>
import CharacterList from '@/components/CharacterList'
import RecentNews from '@/components/RecentNews'

export default {
  name: 'Home',
  components: {
    CharacterList,
    RecentNews
  },
  computed: {}
}
</script>
